import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Steps, Row, Col, Button, message } from 'antd';
import StepOne from './Form_step_0';
import StepTwo from './Form_step_1';
import StepThree from './Form_step_2';
import StepFour from './Form_step_3';

const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'dev-apply-form',
  }
  constructor(props) {
    super(props);
    this.state = {
      step: props.step || 0,
    }
  }
  componentWillReceiveProps(nextProps) {
    const { step } = this.props;
    if (nextProps.step && step !== nextProps.step) {
      this.setState({ step: nextProps.step });
    }
  }
  renderFormStep = () => {
    const { step } = this.state;
    const { formRequiredClass, onChange } = this.props;
    if (step === 1) return <StepTwo form={this.props.form} formRequiredClass={formRequiredClass} onChange={onChange} />
    else if (step === 2) return <StepThree form={this.props.form} formRequiredClass={formRequiredClass} />
    else if (step === 3) return <StepFour form={this.props.form} formRequiredClass={formRequiredClass} onChange={onChange} />
    return <StepOne form={this.props.form} formRequiredClass={formRequiredClass} />;
  }
  render() {
    const { step } = this.state;
    const {
      prefixCls, onStepChange, devStore: { addApplyDev, appDetail, setMobxState, changeCheckboxData, messageConfig },
    } = this.props;
    return (
      <div className={`${prefixCls}`}>
        <Steps current={step} size="small">
          <Steps.Step title="步骤一" description="入口信息" />
          <Steps.Step title="步骤二" description="基本信息" />
          <Steps.Step title="步骤三" description="详情信息" />
          <Steps.Step title="步骤四" description="应用信息" />
        </Steps>
        {this.renderFormStep()}
        <Row>
          <Col span={20} offset={step === 2 ? 0 : 4}>
            <Button type="primary" style={{ marginRight: 10 }} disabled={step === 0} onClick={() => {
              this.setState({ step: step - 1 }, () => {
                onStepChange && onStepChange(this.state.step);
              });
            }}>上一步</Button>
            <Button type="primary" onClick={() => {
              this.props.form.validateFieldsAndScroll((errors, values) => {
                if (!errors) {
                  if (step <= 2) {
                    this.setState({ step: step + 1 }, () => {
                      onStepChange && onStepChange(this.state.step);
                    });
                  }
                  let params = { ...toJS(appDetail), ...values };
                  params = changeCheckboxData(params);
                  setMobxState({ appDetail: params });
                  addApplyDev(values).then(() => {
                    messageConfig();
                    step > 2 && message.success('保存成功');
                  });
                }
              });
            }}>{step === 3 ? '保存' : '下一步'}</Button>
          </Col>
        </Row>
      </div >
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/Form_steped.js